import { render, staticRenderFns } from "./playerList.vue?vue&type=template&id=0ba428e1&scoped=true"
import script from "./playerList.vue?vue&type=script&lang=js"
export * from "./playerList.vue?vue&type=script&lang=js"
import style0 from "./playerList.vue?vue&type=style&index=0&id=0ba428e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba428e1",
  null
  
)

export default component.exports